import React, { useMemo } from 'react'
import { Badge, Box, Divider, HStack, Spacer, Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'

const reportTicketStatus = {
  Undecided: 'secondaryGray',
  Approved: 'acceptanceGreen',
  Approve: 'acceptanceGreen',
  Rejected: 'alertRed',
}

const ReportStaffDetail = ({ reportTicket = {} }) => {
  const isLocked = useMemo(
    () => ['Approved', 'Rejected'].includes(reportTicket.status),
    [reportTicket.status],
  )
  return (
    <>
      <Divider />
      <HStack
        p="12px 32px"
        pointerEvents={isLocked ? 'none' : 'all'}
        opacity={isLocked ? '.5' : '1'}>
        <Box>
          <Text
            textStyle="h4"
            fontWeight="bold">
            {reportTicket.title}
          </Text>
          <Text
            textStyle="tinyHeader"
            mt="3px">
            {reportTicket.notes}
          </Text>
        </Box>
        <Spacer />
      </HStack>
    </>
  )
}

/**
 * @eslint ignore next
 * TODO: this component is not used anywhere, but it is used in the mockup
 * @returns {React.JSX.Element}
 * @constructor
 */
const Cases = () => (
  <Box
    alignSelf="baseline"
    height="100%">
    Cases: <Badge>1</Badge> <Badge>2</Badge> <Badge>3</Badge>
  </Box>
)

ReportStaffDetail.propTypes = {
  reportTicket: PropTypes.shape({
    title: PropTypes.string,
    notes: PropTypes.string,
    status: PropTypes.string,
    id: PropTypes.string,
  }),
}

export default ReportStaffDetail
